import React from 'react';
import Card from "react-bootstrap/Card";
import projImg1 from "../../assets/img/n1.png";
import ShowMoreText from "react-show-more-text";
import projectimage1 from "../../assets/img/np1.png";

const Card1 = () => {
    return (
        <Card className="CARD2" bg="dark">
        {/* <Card.Title><h2>Psychological characteristics behind (academic) performance</h2></Card.Title> */}

        <Card.Img variant="top" src={projectimage1} />
        <br />
        <Card.Body>
          <Card.Text className="ct1">
            {" "}
            <img
              className="img2"
              src={projImg1}
              alt="Modelling industrial policy preferences"
            />{" "}
            <p className="text7">András Bethlendi</p>
            <br />
            <p className="text8">
              Associate Professor, Head of Department{" "}
            </p>
            <p className="text8">Department of Finance, BME </p>
          </Card.Text>
          <ShowMoreText lines={1}>
            <div>
              The economic policy goals are changing. In addition to
              purely economic and political goals, environmental
              protection aspects are becoming more and more prominent. Our
              goal is to model policy preference functions so that
              environmental protection preferences are also displayed. The
              research goal is to build up a model which enables to
              evaluate industrial policies. Firstly, the starting point
              might be the model of Juhasz et al. (2023) incorporating
              (1):{" "}
              <ul>
                <li>
                  Economic performance (g) and related factors (market
                  failure parameter, subsidy, and fiscal cost of
                  government intervention){" "}
                </li>{" "}
                <li>
                  Purely political motives of government over industrial
                  policy Secondly, we intend to add the stability function
                  of government policy.{" "}
                </li>
              </ul>{" "}
              There is a trade-off between economic growth and its
              volatility. We suppose a risk-averse political preference.
              At the same time, the risk can be reduced by
              diversification. (2) Thirdly, we enlarge the model with the
              environmental effect of the industrial policy. We assume an
              environmental function (e.g., CO2 emission) of industries.
              (3) Considering (1)-(3), we calculate a value function, we
              can model government behavior by maximizing this function,
              and choose the optimal industrial policy.
              <br />
              <br />
              Related literature:{" "}
              <ul>
                <li>
                  <a href="https://www.nber.org/papers/w31538#fromrss">
                    {" "}
                    Juhasz, R., Lane, N., &amp; Rodrik, D. (2023). The New
                    Economics of Industrial Policy.
                  </a>
                </li>
              </ul>
            </div>
          </ShowMoreText>
        </Card.Body>
      </Card>
    );
};

export default Card1;
